<template slot-scope="scope">
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :empty-text="HintMsg"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#ffffff',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        :row-style="{ height: '35px' }"
      >
        <el-table-column label="时间" align="center" show-overflow-tooltip width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="IP" align="center" show-overflow-tooltip  width="230">
          <template slot-scope="scope">
            <span
              v-clipboard:copy="scope.row.ip"
              v-clipboard:success="firstCopySuccess"
              v-clipboard:error="firstCopyError"
              >{{ scope.row.ip }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="设备" align="center" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            <span>{{
              scope.row.device == 0
                ? "网站"
                : scope.row.device == 1
                ? "小程序"
                : scope.row.device == 2
                ? "安卓"
                : scope.row.device == 3
                ? "IOS"
                : "--"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="登录者/ID" align="center" show-overflow-tooltip width="230">
          <template slot-scope="scope">
            <span>{{scope.row.username}}/{{scope.row.userCode}}</span>
          </template>
        </el-table-column>
        <el-table-column label="登录方式" align="center" show-overflow-tooltip width="160">
          <template slot-scope="scope">
            <span>{{
              scope.row.loginMethod == "0"
                ? "手机验证码登录"
                : scope.row.loginMethod == "1"
                ? "微信登录"
                : scope.row.loginMethod
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" show-overflow-tooltip fixed="right">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '0'" style="color: #3894ff"
              >正常</span
            >
            <span v-else style="color: #bd3124">异常</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {},
    select: {},
    HintMsg:{},//提示语
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    // 点击 ID 进行复制 复制成功/失败提示
    firstCopySuccess(e) {
      this.$tool.PromptBox("success", "复制成功");
    },
    firstCopyError(e) {
      this.$tool.PromptBox("error", "复制失败");
    },
    handleEdit(index, row) {
      this.dialogVisible = true;
    },

    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px; /* 主内容区水平滚动条高度 */
}

/* 强制右侧固定列高度与主内容区相同 */
::v-deep .el-table__fixed-right {
  height: 100% !important; /* 覆盖默认高度计算 */
}
/* 滚动条滑块（可拖动部分）颜色 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* 灰色滑块，比轨道深一些 */
  border-radius: 4px; /* 可选：滑块圆角 */
}
// 兼容火狐
::v-deep .el-table__body-wrapper {
  /* 控制滚动条粗细（对应 WebKit 的 height:8px） */
  scrollbar-width: thin; /* Firefox 中"thin"约 8px 粗细 */
  /* 控制滑块和轨道颜色（对应 WebKit 的 thumb 和 track） */
  scrollbar-color: #c0c0c0 #f5f5f5; /* 滑块色 + 轨道色 */
}
.table-p {
  display: inline-block;
  width: 75px;
  height: 24px;
  border-radius: 5px;
  background: #409eff ;
  text-align: center;
  color: #ffffff;
  line-height: 24px;
  font-family: PingFangSC-Medium;
  font-size: 10px;
  color: #ffffff;
  text-align: center;
  font-weight: 400;
  margin-right: 10px;
}
.table-added {
  // box-sizing: border-box;
  background: #eeeeee;
  border: 1px solid #999999;
  color: #666666;
  height: 22px;
  line-height: 22px;
}

/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-child(6) {
  border-radius: 0px 10px 0px 0px !important;
}
// /deep/th:nth-last-child(1) {
//   border-radius: 0 10px 0 0 !important;
// }

/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
/deep/.device-list {
  border: 1px solid goldenrod !important;
}
</style>
